/**
 * @generated SignedSource<<487d3228096e141553d2c51f71f1725d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpSharedRecentlyFavoritedCarousel_viewer$data = {
  readonly recentlySavedItems: {
    readonly isFallback: boolean | null;
    readonly items: ReadonlyArray<{
      readonly " $fragmentSpreads": FragmentRefs<"PdpSharedProductTileCarousel_items">;
    } | null> | null;
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedProductTileCarousel_viewer">;
  readonly " $fragmentType": "PdpSharedRecentlyFavoritedCarousel_viewer";
};
export type PdpSharedRecentlyFavoritedCarousel_viewer$key = {
  readonly " $data"?: PdpSharedRecentlyFavoritedCarousel_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedRecentlyFavoritedCarousel_viewer">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "kind": "Variable",
  "name": "userId",
  "variableName": "userId"
};
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "isTrade"
    },
    {
      "kind": "RootArgument",
      "name": "itemId"
    },
    {
      "kind": "RootArgument",
      "name": "priceBookName"
    },
    {
      "kind": "RootArgument",
      "name": "userId"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedRecentlyFavoritedCarousel_viewer",
  "selections": [
    {
      "alias": "recentlySavedItems",
      "args": [
        {
          "kind": "Variable",
          "name": "excludeItemId",
          "variableName": "itemId"
        },
        (v0/*: any*/)
      ],
      "concreteType": "RecentlyFavoritedQuery",
      "kind": "LinkedField",
      "name": "itemRecentlyFavoritedQuery",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Item",
          "kind": "LinkedField",
          "name": "items",
          "plural": true,
          "selections": [
            {
              "args": [
                {
                  "kind": "Variable",
                  "name": "isTrade",
                  "variableName": "isTrade"
                },
                {
                  "kind": "Variable",
                  "name": "priceBookName",
                  "variableName": "priceBookName"
                },
                (v0/*: any*/)
              ],
              "kind": "FragmentSpread",
              "name": "PdpSharedProductTileCarousel_items"
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isFallback",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": [
        (v0/*: any*/)
      ],
      "kind": "FragmentSpread",
      "name": "PdpSharedProductTileCarousel_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};
})();

(node as any).hash = "211141daed1fbf45a748d77b67316238";

export default node;
